import React, { useState } from 'react';
import { debounce } from 'lodash';

import CSSNumberValueControl from 'generics/components/css-number-value-control';

import { normalizeFourSideValues } from '../utilities';

import './index.scss';

function FourSides(props) {

  const [rootState, setRootState] = useState({
    values: normalizeFourSideValues(props.values),
  });

  const onChangeHandler = debounce(props.onChange, 50);

  function handleFourSidesValueChange(value, index) {

    const newValues = [...rootState.values];

    newValues[index] = value;

    onChangeHandler(newValues);

    setRootState({
      ...rootState,
      values: [...newValues]
    });

  }

  function renderValueControl(index) {

    const value = rootState.values[index];
    const valueControlProperties = {
      value,
      onChange(value) {
        handleFourSidesValueChange(value, index);
      }
    };

    return <CSSNumberValueControl {...valueControlProperties} />;

  }

  function renderValueControlSection(index, label) {

    return <div className="side-value-control-section">

      <label className="side-value-control-label field-label">{label}</label>

      {renderValueControl(index)}

    </div>;

  }

  function renderMain() {

    const mainAttributes = {
      className: 'four-sides-input-main'
    };

    const labels = props.labels;

    return <div {...mainAttributes}>

      <div className="four-sides-input-controls">

        {renderValueControlSection(0, labels[0])}
        {renderValueControlSection(1, labels[1])}
        {renderValueControlSection(2, labels[2])}
        {renderValueControlSection(3, labels[3])}

      </div>

    </div>;

  }

  return renderMain();

}

export default FourSides;